// context/DrawerProvider/DrawerProvider.tsx
import React, { createContext, useContext, useRef } from 'react'
import { DrawerStore } from './DrawerStore'

type DrawerAPI = {
  openDrawer: () => void
  closeDrawer: () => void
  openNcoDrawer: () => void
  closeNcoDrawer: () => void
  openMtbDrawer: () => void
  closeMtbDrawer: () => void
  openAccountingDrawer: () => void
  closeAccountingDrawer: () => void
  openProjectDrawer: () => void
  closeProjectDrawer: () => void
}

const DrawerContext = createContext<DrawerAPI | null>(null)

export const DrawerProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const apiRef = useRef<DrawerAPI>({
    openDrawer: () => DrawerStore.openTask(),
    closeDrawer: () => DrawerStore.closeTask(),
    openNcoDrawer: () => DrawerStore.openNco(),
    closeNcoDrawer: () => DrawerStore.closeNco(),
    openMtbDrawer: () => DrawerStore.openMtb(),
    closeMtbDrawer: () => DrawerStore.closeMtb(),
    openAccountingDrawer: () => DrawerStore.openAccounting(),
    closeAccountingDrawer: () => DrawerStore.closeAccounting(),
    openProjectDrawer: () => DrawerStore.openProject(),
    closeProjectDrawer: () => DrawerStore.closeProject(),
  })

  return <DrawerContext.Provider value={apiRef.current}>{children}</DrawerContext.Provider>
}

export const useDrawerContext = () => {
  const ctx = useContext(DrawerContext)
  if (!ctx) throw new Error('useDrawerContext must be used within DrawerProvider')
  return ctx
}
